<terra-main-nav [showNav]="false" [showAccountActions]="false"></terra-main-nav>

<section class="container-small" *ngIf="{ clientDetails: clientDetails$ | async } as data">

  <ng-container *ngIf="{logoData: referrerLogo$ | async} as referrer">
    <img class="referrer-logo" *ngIf="referrer?.logoData?.showLogo" [src]="referrer?.logoData?.logoUrl"/>
  </ng-container>
  
  <h1>Almost done!</h1>
  <ng-template #pageLoader>
    <terra-loader></terra-loader>
  </ng-template>

  <ng-container *ngIf="data.clientDetails && !isSendingEmail; else pageLoader">
    <p class="description">
      We now need to verify your email address. We've sent an email to <i>{{ data.clientDetails.email }}</i> to verify your address.
    </p>
    <p class="description bold">
      Please click the button in that email to finish setting up your account.
    </p>

    <form class="terra-error-style" [formGroup]="pageForm">
      <!-- Email -->
      <div class="hint-section">
        <p>
          Wrong email?
          <a class="link" [routerLink]="routingService.myAccountPage" routerLinkActive="router-link-active">Change your address</a>
        </p>
        <div>
          <p *ngIf="!resendSuccessful">
            Didn't get the email?
            <a class="link" (click)="resendConfirmationEmail(true)" routerLinkActive="router-link-active">Resend confirmation email</a>
          </p>

          <p *ngIf="resendSuccessful">
            Email sent!
          </p>
        </div>
      </div>

      <div *ngIf="hasError">
        <h1>An error has occurred</h1>
        <p>
          An error has occurred, please try again or contact support
        </p>
      </div>
    </form>
  </ng-container>

  <ul class="footer-links">
    <li class="footer-li">
      <a mat-button class="footer-link" routerLink="/logout"><mat-icon class="footer-link-icon notranslate">keyboard_backspace</mat-icon>Back to login</a>
    </li>
    <li class="footer-li">
      <a target="_blank" mat-button class="footer-link" href="//www.covercy.com/contact-us">
        <mat-icon class="footer-link-icon notranslate">question_answer</mat-icon>
        Covercy contact details
      </a>
    </li>
  </ul>
</section>
